export default "__VITE_ASSET__89b3z4_u__"